/* Cart drawer add-on toggle.
   Adds or removes a real product line, then lets the theme re-render the cart.
   Delegated so it keeps working after the drawer re-renders. */
(function () {
  var BUSY = 'aria-busy';

  function refreshCart() {
    // Horizon re-renders the drawer on this event; fall back to a reload.
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    setTimeout(function () {
      if (document.querySelector('.nm-cart-addon__toggle[aria-busy="true"]')) {
        window.location.reload();
      }
    }, 2500);
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.nm-cart-addon__toggle');
    if (!btn) return;

    event.preventDefault();
    if (btn.getAttribute(BUSY) === 'true') return;

    var variantId = btn.getAttribute('data-nm-addon-variant');
    var lineKey = btn.getAttribute('data-nm-addon-key');
    var isOn = btn.classList.contains('is-on');
    if (!variantId) return;

    btn.setAttribute(BUSY, 'true');

    // Optimistic flip so the control feels immediate; reverted on failure.
    btn.classList.toggle('is-on', !isOn);
    btn.setAttribute('aria-checked', String(!isOn));

    var request = isOn
      ? post('/cart/change.js', { id: lineKey || variantId, quantity: 0 })
      : post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });

    request
      .then(function (res) {
        if (!res.ok) throw new Error('cart update failed: ' + res.status);
        refreshCart();
      })
      .catch(function () {
        // Put the control back where it was rather than leaving it lying.
        btn.classList.toggle('is-on', isOn);
        btn.setAttribute('aria-checked', String(isOn));
        btn.removeAttribute(BUSY);
      });
  });
})();
